module.exports = __webpack_public_path__ + "static/siemens_logo-f761aa3911c511611708765b1b343a18.svg";